module.exports = __webpack_public_path__ + "static/media/icon-star-gray.06c57fec.svg";